<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div></div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addUser"
          style="width: 90px"
          >新增</el-button
        >
        <!-- <el-button size='small' @click="" type="success" style="width:90px">搜索</el-button>
             <el-button size='small' @click="" type="danger" style="width:90px">重置</el-button> -->
      </div>
      <el-table
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        height="1000"
        border
        :tree-props="{ children: 'children' }"
      >
        <el-table-column prop="sort" label="排序" align="center" width="100">
        </el-table-column>
        <el-table-column label="图标" align="center" width="180">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>

            　　
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="菜单名称">
        </el-table-column>
        <el-table-column
          prop="type"
          label="菜单类型"
          align="center"
          :formatter="menuType"
        >
        </el-table-column>

        <el-table-column prop="api" align="center" label="菜单路径">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope)"
              >修改</el-button
            >
            <el-button type="text" size="small" @click="del(scope)">
              删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-form-item label="图标" prop="icon">
              <el-input
                  v-model="addData.icon"
                ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input
                  v-model="addData.sort"
                  placeholder="请输入排序方式"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="菜单名称" prop="title">
                <el-input
                  v-model="addData.title"
                  placeholder="请输入菜单名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="上级菜单" prop="pid">
                <el-select
                  v-model="addData.pid"
                  placeholder="请选择上级菜单"
                  style="width: 270px"
                >
                  <el-option
                    v-for="(item, index) in parentList"
                    :label="item.title"
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="菜单路径" prop="api">
                <el-input
                  v-model="addData.api"
                  placeholder="请输入菜单路径"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="菜单类型" prop="type">
                <el-radio-group v-model="addData.type">
                  <el-radio label="0">目录</el-radio>
                  <el-radio label="1">菜单</el-radio>
                  <el-radio label="2">按钮</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  v-model="addData.remark"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="success" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
 
 <script>
 import {
  rulelists,
  ruleparents,
  ruleAdd,
  ruleEdit
} from "../api/menu.js";
export default {
  data() {
    return {
      modalTitle: "新增",
      tableData: [],
      addData: {
        icon: "el-icon-s-tools",
        type: "0", //菜单类型 0 目录  1菜单 2按钮
        title: "", //菜单名称
        api: "", //菜单路径
        sort: 0, //排序
        remark: "", //备注
        pid: "", //上级菜单
      },
      parentList: [], //上级菜单列表
      addDataRules: {
        // icon: [{ required: true, message: "请选择图标", trigger: "blur" }],
        // type: [{ required: true, message: "请选择菜单类型", trigger: "blur" }],
        // sort: [{ required: true, message: "请输入排序方式", trigger: "blur" }],
        // path: [{ required: false, message: "请输入菜单路径", trigger: "blur" }],
        // remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        // title: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        // parentId: [
        //   { required: false, message: "请选择上级菜单", trigger: "blur" },
        // ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    menuType(row) {
      let rowStr = ["目录", "菜单", "按钮"];
      return rowStr[row.type];
    },
    // 新增菜单
    addUser() {
      this.modalTitle = "新增";

      this.addData.icon = "";
      // this.addData.type = "0";
      this.addData.title = "";
      this.addData.api = "";
      this.addData.sort = "";
      // this.addData.remark = "";
      this.addData.pid = "";

      this.isAddModal = true;
      this.$refs.form.clearValidate();
    },
    // 修改菜单
    updata(row) {
      this.addData.id = row.row.id;
      this.addData.icon = row.row.icon;
      // this.addData.type = String(row.row.type);
      this.addData.title = row.row.title;
      this.addData.api = row.row.api;
      this.addData.sort = row.row.sort;
      // this.addData.remark = row.row.remark;
      if (row.row.pid == 0) {
        this.addData.pid = "";
      } else {
        this.addData.pid = row.row.pid;
      }

      this.modalTitle = "修改";

      this.isAddModal = true;
      this.$refs.form.clearValidate();
    },
    del(row) {
      let id = row.row.id;
      if (row.row.children.length > 0) {
        this.$message.warning("删除失败，改菜单存在子项，请先删除子项");
        return;
      }
      this.$confirm("您确定要删除此项", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(this.$Apis, "this");
          this.$Apis.menuDel({ menuId: id }).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.onLoad();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let url = ruleAdd
          let data = {
            // type: this.addData.type,
            title: this.addData.title,
            api: this.addData.api,
            sort: this.addData.sort,
            // remark: this.addData.remark,
            pid: this.addData.pid || 0,
            // pid:0,
            key:'menus',
            type:1,
            icon: this.addData.icon,
          };

          if (this.modalTitle == "修改") {
            data.id = this.addData.id;
            url = ruleEdit
          }

          console.log("请求的数据", data);

          url(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    onLoad() {
      this.isShowloading = true;

      rulelists().then((res) => {
        this.isShowloading = false;
        if (res.status_code == 200) {
          this.parentList = res.data;
          this.tableData = res.data;
        }
      });
    },
  },
};
</script>
 
 <style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
</style>